import React from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/free-regular-svg-icons';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { useState, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { getDateFormat, getDateTimeFormat } from '../../../helpers/dateFormat';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../features/template/store';
import { getCurrencyDDList } from "../../features/quickpay/actions/quickPayActions";
import {
  getCustomersDetailsByPartnerId
} from "../../features/profile/action/ProfileAccount";

import ManualInvoiceDataTable from '../../features/payment/ManualInvoiceDataTable';
import { getCountryList } from "../../features/registration/actions/Registration";
import { fetchLinerNameByCountry } from "../../features/registration/actions/Registration";
import { FormProvider, useForm, Controller } from 'react-hook-form';
import { addInvoiceManually } from '../blPayment/actions/payments';
import UnsavedChangesModal from '../../../components/common/UnsavedChangesModal';
import { useBackNavigation } from '../../../hooks/BackNavigation';
import { useFormNavigationWarning } from '../../../hooks/useFormNavigationWarning';
import { setDirty } from '../formDirtySlice';

const ManualInvoice = ({ backPath }: { backPath: string }) => {

  const [clearable, setClearable] = useState(true);
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);

  console.log("manual invoice component");
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [shippingLineOptions, setShippingLineOptions] = useState<{ value: string; text: string }[]>([]);
  const currencyList = useSelector((state: RootState) => state.quickpay.currencyList)
  const linerCountryList = useSelector(
    (state: RootState) => state.registration.countryOptions
  );
    const isDirty = useSelector((state:RootState) => state.formDirty.isDirty);
  const _onCloseForm = () => {

    //navigate(backPath);
      const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
    navigate(`${APP_PATH_PREFIX}/payment`)
  };

  interface IManualInvoiceList {
    rowNumber: string;
    blNumber: string;
    invoiceNumber: string;
    invoiceDate: Date | null;
    invoiceAmount: number | null;
  }
  type FormValues = {
    shippingLine: string;
    countryType: string;
    invoiceDate: Date | null;
    currencyType: string;
    blNumber: string;
    remarks: string;
    fisCall: 'Y' | 'N';
    manualInvoiceList: IManualInvoiceList[];
  };

  const validationSchema = Yup.object({
    shippingLine: Yup.string()
      .required('Shipping Line is required'),

    countryType: Yup.string()
      .required('Country is required'),

    currencyType: Yup.string()
      .required('Currency is required'),

    fisCall: Yup.string()
      .nullable()
      .required('FIS Call is required')
      .oneOf(['Y', 'N'], 'FIS Call must be Yes or No'),

    remarks: Yup.string()
      .required('Remarks are required')
      .max(150, 'Remarks cannot be longer than 150 characters'),

    manualInvoiceList: Yup.array()
      .of(
        Yup.object().shape({
          rowNumber: Yup.string().required('Row number is required'),
          blNumber: Yup.string().required('BL Number is required'),
          invoiceDate: Yup.string().required('Invoice Date is required'),
          invoiceNumber: Yup.string().required('Invoice Number  is required'),
          invoiceAmount: Yup.number().required('Invoice Amount is required'),

        })
      )
  });


  const methods = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      shippingLine: "",
      fisCall: 'N',
      manualInvoiceList: [{
        rowNumber: crypto.randomUUID(),
        blNumber: "",
        invoiceNumber: "",
        invoiceDate: null,
        invoiceAmount: null
      }],

    },
    mode: 'onSubmit',
  });

  const shippingLine = methods.watch("shippingLine");

  const showFISCall = shippingLine == "1";
  const onSubmitForm = methods.handleSubmit(async (payload) => {
    dispatch(addInvoiceManually(payload))
  })


  useEffect(() => {
    if (methods.watch("countryType")) {
      dispatch(getCurrencyDDList({ country: methods.watch("countryType") }))
      dispatch(fetchLinerNameByCountry({ country_code: methods.watch("countryType") }))
        .unwrap()
        .then((data: any[]) => {
          setShippingLineOptions(data);
          methods.setValue("shippingLine", `${data[0].value}`);
        })
        .catch((err) => {
          console.error("Failed to fetch liner names", err);
        });
    } else {
      setShippingLineOptions([])
    }
  }, [methods.watch("countryType")])


  useEffect(() => {
    if (currencyList.length > 0 && !methods.getValues('currencyType')) {
      methods.setValue('currencyType', currencyList[0].currencyCode, { shouldValidate: true });
    }
  }, [currencyList, methods.setValue, methods.getValues]);


  useEffect(() => {

    dispatch(getCountryList(1))

  }, []);

  useEffect(() => {
    methods.setValue('shippingLine', "")
    methods.setValue('countryType', "")
    methods.setValue('currencyType', "")
    methods.setValue("manualInvoiceList", [
      {
        rowNumber: crypto.randomUUID(),
        blNumber: "",
        invoiceNumber: "",
        invoiceDate: null,
        invoiceAmount: null
      }
    ])
    return
  }, [])
  const onBack = useBackNavigation();
const { showModal, handleNavigation, handleConfirm, handleCancel, handleBack } = useFormNavigationWarning({
  isChanged: isDirty,
  isEditable: true,
  onConfirm:  onBack // or onBack, or your navigation function
});
  
    const handleStayOnPage = () => {
      handleCancel();
    };
  
    const handleLeavePage = () => {
      onBack()
    };

  

  return (
    <>
      <Card className='h-100 overflow-auto'>
         <UnsavedChangesModal
                      show={showModal}
                      onHide={handleStayOnPage}
                      onConfirm={handleLeavePage}
                    />
        <Card.Header className='d-flex align-items-center border-bottom sticky-top bg-white'>
          <FontAwesomeIcon
            icon={faArrowAltCircleLeft}
            className='text-warning cursor-pointer fa-lg  me-1'
            onClick={handleBack}
          />
          <h2 className='fs-0 text-primary mb-1'>Manual Invoice Details</h2>
        </Card.Header>

        <Card.Body>
          <FormProvider {...methods}>
            <Form autoComplete='off' onSubmit={onSubmitForm}>
              <div className='row'>
                <div className='col-lg-4 mb-3 '>
                  <span className='mandatory'>*</span>
                  <Form.Label>   Country </Form.Label>
                  <Form.Select
                    {...methods.register("countryType")}
                    onChange={(e: any) => {
                      methods.setValue("countryType", e.target.value, { shouldValidate: true,shouldDirty:true });
                      dispatch(setDirty())
                    }}
                    value={methods.watch('countryType')}
                    className={`fs--1 ${methods.formState.errors?.countryType ? "is-invalid" : ""
                      }`}
                  >
                    <option
                      key=""
                      value=""
                    >
                    </option>
                    {
                      linerCountryList.map((option: any) => (
                        <option
                          value={option.value}
                        >
                          {option.text}
                        </option>
                      ))
                    }

                  </Form.Select>
                  <div className='invalid-feedback'>
                    {methods.formState.errors.countryType?.message?.toString()}
                  </div>
                </div>
                <div className='col-lg-3 mb-4'>
                  <span className="mandatory">*</span>
                  <Form.Label className='fs--1'>
                    Shipping Line

                  </Form.Label>
                  <Form.Group className="">
                    <Form.Select
                      className="fs--1 form-control form-select"
                      value={methods.watch("shippingLine")}
                      onChange={(e)=>{{methods.setValue("shippingLine",e.target.value);   dispatch(setDirty())}}}
                      isInvalid={!!methods.formState.errors.shippingLine}
                    >
                      {shippingLineOptions.map((option) => (
                        <option value={option.value}>
                          {option.text}
                        </option>
                      ))}

                    </Form.Select>

                  </Form.Group>

                  <div className='invalid-feedback d-block'>

                    {methods.formState.errors.shippingLine?.message?.toString()}
                  </div>

                </div>

                <div className='col-lg-2 mb-3'>
                  <span className="mandatory">*</span>
                  <Form.Label className='fs--1'>
                    Currency
                  </Form.Label>

                  <Form.Group className="">
                    <Form.Select
                      className="fs--1 form-control form-select"
                      {...methods.register("currencyType")}
                      isInvalid={!!methods.formState.errors.currencyType}
                    >

                      {currencyList.map((option: any) => (
                        <option key={option.currencyCode} value={option.currencyCode}>
                          {option.currencyShortName}
                        </option>
                      ))}
                    </Form.Select>

                  </Form.Group>

                  <div className='invalid-feedback d-block'>
                    {methods.formState.errors.currencyType?.message?.toString()}
                  </div>
                </div>

                {showFISCall && (
                  <>
                    <div className='col-lg-3 mb-3'>
                      <span className="mandatory">*</span>
                      <Form.Label className='fs--1'>FIS Call</Form.Label>

                      <div
                        className={`d-flex gap-3 ${methods.formState.errors.fisCall ? 'is-invalid' : ''}`}
                        role="group"
                        aria-labelledby="fisCall-radio-group"
                      >
                        <Form.Check
                          type="radio"
                          label="Yes"
                          value="Y"
                          id="fisCallYes"
                          {...methods.register('fisCall')}
                          name="fisCall"
                          isInvalid={!!methods.formState.errors.fisCall}

                        />
                        <Form.Check
                          type="radio"
                          label="No"
                          value="N"
                          id="fisCallNo"
                          {...methods.register('fisCall')}
                          name="fisCall"
                          isInvalid={!!methods.formState.errors.fisCall}

                        />
                      </div>
                      <div className='invalid-feedback d-block'>
                        {methods.formState.errors.fisCall?.message?.toString()}
                      </div>
                    </div>
                  </>
                )}

                <div className='col-lg-6 mb-2'>
                  <span className="mandatory">*</span>
                  <Form.Label className='fs--1'>
                    Remarks
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    {...methods.register("remarks")}
                    isInvalid={!!methods.formState.errors.remarks}
                    className='fs--1'
                    type="text"
                    rows={2}
                    maxLength={150}
                    onBlur={(e) => {
                      const trimmed = e.target.value.trim();
                      methods.setValue("remarks", trimmed,{shouldDirty:true});
                    }}

                  >
                  </Form.Control>

                </div>
                <div className='invalid-feedback d-block'>

                  {methods.formState.errors.remarks?.message?.toString()}
                </div>
              </div>
              <br>
              </br>

              <ManualInvoiceDataTable />
              <div className='d-flex justify-content-center align-items-center'>

                <Button
                  className='me-2'
                  variant='falcon-primary'
                  size='sm'
                  data-placement="left"
                  data-toggle="tooltip"
                  onClick={onSubmitForm}
                  style={{ marginRight: '0.5rem', position: 'relative' }}
                  onChange={() => { }}
                  type="submit"
                >

                  <FontAwesomeIcon icon={faSave} className='mx-1 me-2 mt-1 text-warning' />
                  <span>Submit</span>
                </Button>

              </div>
            </Form>
          </FormProvider>
        </Card.Body>
      </Card>
      <UnsavedChangesModal
        show={showUnsavedModal}
        onHide={handleStayOnPage}
        onConfirm={handleLeavePage}
      />
    </>
  );
};

export default ManualInvoice;


